const { serialize } = require("../../utils");

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-parents",
  },
  actions: {
    auth({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/auth`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    knowledgeGroupResponsibles({ dispatch, state }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/knowledge-group-responsibles?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    visits({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/visits?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    payments({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/payments?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    events({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/events?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    certificates({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/certificates?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    appropriations({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/appropriations?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    homeWorkAppropriations({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/homework-appropriations?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    behaviors({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/behaviors?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    survey({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/survey?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    sendSurveyAnswer({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-survey-answer`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getBotReports({ dispatch, state, rootState }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-bot-reports`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    blockUser({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/block-user`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    UnblockUser({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/unblock-user`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    sendMessageToUser({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-message-to-user`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    updateUsersCredentionals({ dispatch, state, rootState }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update-users-credentionals`,
          method: "POST",
          data: {},
        },
        { root: true }
      );
    },
    getByGroup({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-by-groups?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    updateStudentAvatar({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/update-student-avatar`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    removeTelegramBotUser({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/remove-telegram-bot-user`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    lessonsSchedules({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/lessons-schedules?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    reInitParentChildrens({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/re-init-parent-childrens`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    reInitParentBotButtons({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/re-init-parents-bot-buttons`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    chats({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/chats?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    addNewChat({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-new-chat`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    addNewMessageToChat({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-new-message-to-chat`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    ratingChat({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/rating-chat`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    canSendChat({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/can-send-chat?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    escalateChatToDirector({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/escalate-chat-to-director`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    noSendedBirthCertificateChildrens({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/no-sended-birth-certificate-childrens?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    sendBirthCertificate({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-birth-certificate`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    optionalLessons({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/optional-lessons?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    sendConfirmOptionalLesson({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-confirm-optional-lesson`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getSpecialAudio({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-special-audio?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    saveSpecialAudioStatus({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/save-special-audio-event`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    monitoring({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `aljabr/telegram-parents-monitoring/?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    sendQuestionnaire({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-questionnaire`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getCampData({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/get-camps?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    sendCampRequest({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-camp-request`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    sendPaymentScreenshot({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/send-payment-screenshot`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    getAvailableHouses({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/get-available-houses`, method: "POST", data }, { root: true });
    },
    submitMeetingRequest({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/submit-meeting-request`, method: "POST", data }, { root: true });
    },
    nurseGetExcuseData({ dispatch, state, rootState }, options) {
      return dispatch("FETCH", { url: `${state.path}/nurse-get-excuse-data?${serialize(options)}`, method: "GET", data: {} }, { root: true });
    },
    schoolSupplies({ dispatch, state, rootState }, options) {
      return dispatch("FETCH", { url: `${state.path}/school-supplies?${serialize(options)}`, method: "GET", data: {} }, { root: true });
    },
    addNewSchoolChat({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-new-school-chat`, method: "POST", data }, { root: true });
    },
    addNewJuristChat({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/add-new-jurist-chat`, method: "POST", data }, { root: true });
    },
    children({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/children?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    starHistory({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/star-history?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    addStar({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-star`,
          method: "POST",
          data: data,
        },
        { root: true }
      );
    },
    academicYears({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/academic-years?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    finishChat({ dispatch, state, rootState }, data) {
      return dispatch("FETCH", { url: `${state.path}/finish-chat`, method: "POST", data }, { root: true });
    },
  },
};
